import type { ReactEventHandler } from 'react';
import type { ImagePrompt, ImagePromptWithSize } from '@/app/types';

export const createImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const imageInstance = new Image();
    imageInstance.crossOrigin = 'anonymous';
    imageInstance.onload = () => {
      resolve(imageInstance);
    };
    imageInstance.onerror = () => {
      reject(new Error('loadImageError'));
    };
    imageInstance.src = url;
  });

export const getImageSize = async (
  url: string,
): Promise<{
  width: number;
  height: number;
  image: HTMLImageElement;
}> => {
  const image = await createImage(url);
  return { width: image.width, height: image.height, image };
};

// 检查图片是否存在原始宽高信息
export const checkSourceImageSize = (image: ImagePrompt | null): image is ImagePromptWithSize => {
  return Boolean(image && image.sourceImageWidth !== undefined && image.sourceImageHeight !== undefined);
};

export const checkTwoImageSizes = (
  images: [ImagePrompt | null, ImagePrompt | null],
): images is [ImagePromptWithSize, ImagePromptWithSize] => {
  return images.every(checkSourceImageSize);
};

/**
 * 图像加载失败时，将源改为 1px 的透明图，避免出现加载失败的样式
 * @param e
 * @returns void
 */
export const imageErrorHandler: ReactEventHandler<HTMLImageElement> = (e) => {
  (e.target as HTMLImageElement).src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  // 为加载报错的图片添加 data-status="error" 的属性，可用于 css 与 js 处理
  (e.target as HTMLImageElement).dataset.status = 'error';
};
